module.exports = __webpack_public_path__ + "static/Ilustration_duefocus_jira-f6cc3509eb2bb4854c2c19bdf9fe279d.png";